/* tslint:disable */
/* eslint-disable */
/**
 * Unnamed Galvyn API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiErrorResponse,
  ClubSchema,
  CreateMemberInviteRequest,
  CredentialResetSchema,
  DashboardStatsSchema,
  FormResultForSingleLinkAndCreateInviteError,
  GetInvite,
  PageForSimpleMemberAccountSchema,
} from '../models/index';

export interface CreateMemberInviteOperationRequest {
    club_uuid: string;
    CreateMemberInviteRequest?: CreateMemberInviteRequest;
}

export interface DeleteMemberRequest {
    club_uuid: string;
    member_uuid: string;
}

export interface GetClubRequest {
    club_uuid: string;
}

export interface GetClubMemberInvitesRequest {
    club_uuid: string;
}

export interface GetClubMembersRequest {
    club_uuid: string;
    limit?: number;
    offset?: number;
    search?: string | null;
}

export interface GetDashboardStatsRequest {
    club_uuid: string;
}

export interface ResetCredentialsRequest {
    club_uuid: string;
    uuid: string;
}

export interface RetractInviteRequest {
    club_uuid: string;
    uuid: string;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     */
    async createMemberInviteRaw(requestParameters: CreateMemberInviteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForSingleLinkAndCreateInviteError>> {
        if (requestParameters['club_uuid'] == null) {
            throw new runtime.RequiredError(
                'club_uuid',
                'Required parameter "club_uuid" was null or undefined when calling createMemberInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/frontend/club-admin/clubs/{club_uuid}/invites`.replace(`{${"club_uuid"}}`, encodeURIComponent(String(requestParameters['club_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateMemberInviteRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createMemberInvite(requestParameters: CreateMemberInviteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForSingleLinkAndCreateInviteError> {
        const response = await this.createMemberInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteMemberRaw(requestParameters: DeleteMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['club_uuid'] == null) {
            throw new runtime.RequiredError(
                'club_uuid',
                'Required parameter "club_uuid" was null or undefined when calling deleteMember().'
            );
        }

        if (requestParameters['member_uuid'] == null) {
            throw new runtime.RequiredError(
                'member_uuid',
                'Required parameter "member_uuid" was null or undefined when calling deleteMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/club-admin/clubs/{club_uuid}/members/{member_uuid}`.replace(`{${"club_uuid"}}`, encodeURIComponent(String(requestParameters['club_uuid']))).replace(`{${"member_uuid"}}`, encodeURIComponent(String(requestParameters['member_uuid']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteMember(requestParameters: DeleteMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMemberRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getClubRaw(requestParameters: GetClubRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClubSchema>> {
        if (requestParameters['club_uuid'] == null) {
            throw new runtime.RequiredError(
                'club_uuid',
                'Required parameter "club_uuid" was null or undefined when calling getClub().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/club-admin/clubs/{club_uuid}/club`.replace(`{${"club_uuid"}}`, encodeURIComponent(String(requestParameters['club_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getClub(requestParameters: GetClubRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClubSchema> {
        const response = await this.getClubRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClubMemberInvitesRaw(requestParameters: GetClubMemberInvitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetInvite>>> {
        if (requestParameters['club_uuid'] == null) {
            throw new runtime.RequiredError(
                'club_uuid',
                'Required parameter "club_uuid" was null or undefined when calling getClubMemberInvites().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/club-admin/clubs/{club_uuid}/club/members/invites`.replace(`{${"club_uuid"}}`, encodeURIComponent(String(requestParameters['club_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getClubMemberInvites(requestParameters: GetClubMemberInvitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetInvite>> {
        const response = await this.getClubMemberInvitesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClubMembersRaw(requestParameters: GetClubMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForSimpleMemberAccountSchema>> {
        if (requestParameters['club_uuid'] == null) {
            throw new runtime.RequiredError(
                'club_uuid',
                'Required parameter "club_uuid" was null or undefined when calling getClubMembers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/club-admin/clubs/{club_uuid}/club/members`.replace(`{${"club_uuid"}}`, encodeURIComponent(String(requestParameters['club_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getClubMembers(requestParameters: GetClubMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForSimpleMemberAccountSchema> {
        const response = await this.getClubMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDashboardStatsRaw(requestParameters: GetDashboardStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardStatsSchema>> {
        if (requestParameters['club_uuid'] == null) {
            throw new runtime.RequiredError(
                'club_uuid',
                'Required parameter "club_uuid" was null or undefined when calling getDashboardStats().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/club-admin/clubs/{club_uuid}/club/dashboard-stats`.replace(`{${"club_uuid"}}`, encodeURIComponent(String(requestParameters['club_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getDashboardStats(requestParameters: GetDashboardStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardStatsSchema> {
        const response = await this.getDashboardStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async resetCredentialsRaw(requestParameters: ResetCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CredentialResetSchema>> {
        if (requestParameters['club_uuid'] == null) {
            throw new runtime.RequiredError(
                'club_uuid',
                'Required parameter "club_uuid" was null or undefined when calling resetCredentials().'
            );
        }

        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling resetCredentials().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/club-admin/clubs/{club_uuid}/members/{uuid}/reset-credentials`.replace(`{${"club_uuid"}}`, encodeURIComponent(String(requestParameters['club_uuid']))).replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async resetCredentials(requestParameters: ResetCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CredentialResetSchema> {
        const response = await this.resetCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async retractInviteRaw(requestParameters: RetractInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['club_uuid'] == null) {
            throw new runtime.RequiredError(
                'club_uuid',
                'Required parameter "club_uuid" was null or undefined when calling retractInvite().'
            );
        }

        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling retractInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/club-admin/clubs/{club_uuid}/invites/{uuid}/retract`.replace(`{${"club_uuid"}}`, encodeURIComponent(String(requestParameters['club_uuid']))).replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async retractInvite(requestParameters: RetractInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.retractInviteRaw(requestParameters, initOverrides);
    }

}
